import React, { useState } from 'react';

import { useFormik } from 'formik';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { changeName } from 'api/endpoints/user';
import Button from 'components/Button';
import ErrorMessage from 'components/ErrorMessage';
import Input from 'components/Input';
import useUser from 'hooks/useUser';
import { toastError, toastSuccess } from 'lib/toast';
import { setLoading } from 'store/actions/common';

const UpdateName = ({ back }) => {
  const { t } = useTranslation();
  const { me } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const { getMe } = useUser();
  const [isSubmitted, setIsSubmitted] = useState(false);

  const initialValues = {
    name: me.name,
  };

  const handleChangeName = async (values) => {
    try {
      dispatch(setLoading({ isOpen: true }));
      await changeName({ name: values.name })
        .then(async (response) => {
          toastSuccess(response?.message || '');
          getMe();
          back();
        })
        .catch((errors) => {
          toastError(errors.message);
        });
      dispatch(setLoading({ isOpen: false }));
    } catch {
      //  Handle error
      dispatch(setLoading({ isOpen: false }));
    }
  };

  const form = useFormik({
    initialValues: initialValues,
    validateOnChange: isSubmitted,
    validateOnBlur: false,
    validate: (values) => {
      const errors = {};

      if (!values.name) errors.name = true;

      setIsSubmitted(true);
      return errors;
    },
    onSubmit: async (values) => {
      await handleChangeName(values);
    },
  });

  return (
    <>
      <div className="flex-between-center px-6 py-4 border-b border-white-720">
        <p className="font-bold">{t('TITLE_FULL_NAME_EDITING')}</p>
      </div>

      <div className="p-6">
        <fieldset>
          <p className="text-black/85 mb-2 flex items-center">
            <span className="text-danger-411 mr-1">
              <img src={require('assets/resources/Required.svg').default} alt="required" width={7} height={7} />
            </span>
            {t('FULL_NAME')}
          </p>
          <Input
            id="name"
            name="name"
            type="text"
            value={form.values.name}
            onChange={form.handleChange}
            className="w-full"
            invalid={form.errors.name}
          />

          <p className="text-sm text-danger-229">{!form.values.name && form.errors.name && <ErrorMessage>{t('NOT_EMPTY')}</ErrorMessage>}</p>
        </fieldset>
      </div>

      <div className="h-16 border-t border-white-720 flex-end-center gap-2 py-4 px-6">
        <Button className="h-8 w-25.5 text-sm" text={t('CANCEL_TEXT')} color="outline" onClick={back} />
        <Button className="h-8 w-20 text-sm" text={t('RENEW')} color="primary" onClick={form.handleSubmit} />
      </div>
    </>
  );
};

export default React.memo(UpdateName);
